/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JumboGetdefendifydevicesettingsGetDefendifyDeviceSettingResult
 */
export interface JumboGetdefendifydevicesettingsGetDefendifyDeviceSettingResult {
    /**
     * 
     * @type {boolean}
     * @memberof JumboGetdefendifydevicesettingsGetDefendifyDeviceSettingResult
     */
    antivirusEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JumboGetdefendifydevicesettingsGetDefendifyDeviceSettingResult
     */
    lastSyncedAt?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof JumboGetdefendifydevicesettingsGetDefendifyDeviceSettingResult
     */
    tamperProtectionEnabled?: boolean;
}

/**
 * Check if a given object implements the JumboGetdefendifydevicesettingsGetDefendifyDeviceSettingResult interface.
 */
export function instanceOfJumboGetdefendifydevicesettingsGetDefendifyDeviceSettingResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboGetdefendifydevicesettingsGetDefendifyDeviceSettingResultFromJSON(json: any): JumboGetdefendifydevicesettingsGetDefendifyDeviceSettingResult {
    return JumboGetdefendifydevicesettingsGetDefendifyDeviceSettingResultFromJSONTyped(json, false);
}

export function JumboGetdefendifydevicesettingsGetDefendifyDeviceSettingResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboGetdefendifydevicesettingsGetDefendifyDeviceSettingResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'antivirusEnabled': !exists(json, 'antivirusEnabled') ? undefined : json['antivirusEnabled'],
        'lastSyncedAt': !exists(json, 'lastSyncedAt') ? undefined : json['lastSyncedAt'],
        'tamperProtectionEnabled': !exists(json, 'tamperProtectionEnabled') ? undefined : json['tamperProtectionEnabled'],
    };
}

export function JumboGetdefendifydevicesettingsGetDefendifyDeviceSettingResultToJSON(value?: JumboGetdefendifydevicesettingsGetDefendifyDeviceSettingResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'antivirusEnabled': value.antivirusEnabled,
        'lastSyncedAt': value.lastSyncedAt,
        'tamperProtectionEnabled': value.tamperProtectionEnabled,
    };
}

